/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MaintenanceMessage = {
    /**
     * title of the messge to show to users
     */
    title: string;
    /**
     * message to show to users
     */
    message?: string | null;
    /**
     * The type of alert, which also determines the style and color it's displayed as
     */
    type: MaintenanceMessage.type;
    /**
     * whether or not to show the message
     */
    is_active: boolean;
}

export namespace MaintenanceMessage {

    /**
     * The type of alert, which also determines the style and color it's displayed as
     */
    export enum type {
        MAINTENANCE = 'maintenance',
        ALERT = 'alert',
        NOTE = 'note',
        RESOLVED = 'resolved',
    }


}
